// @ts-nocheck

import { createSelector } from 'reselect';

import { KLRoundViewByOrder } from '../../constants/order';
import { selectKLGlobalStatus } from '../global';
import { selectKLHomeNavigationIsAllowed, selectKLHomeVisitedIndex } from '../misc';
import { selectIsKLUserEliminated, selectKLUserRoundIndex } from '../user';

const selectIndex = createSelector(
  [selectKLUserRoundIndex, selectKLHomeVisitedIndex, selectIsKLUserEliminated],
  (userRoundIndex, homeVisitedIndex, isUserEliminated) =>
    homeVisitedIndex ?? (isUserEliminated ? KLRoundViewByOrder.length : userRoundIndex),
);

const selectKLHomeProps = createSelector(
  [
    selectIndex,
    selectKLUserRoundIndex,
    selectIsKLUserEliminated,
    selectKLHomeNavigationIsAllowed,
    selectKLGlobalStatus,
  ],
  (index, userRoundIndex, isUserEliminated, navigationIsAllowed, globalStatus) => ({
    index,
    userRoundIndex,
    isUserEliminated,
    navigationIsAllowed,
    globalStatus,
  }),
);

export default selectKLHomeProps;
